
export default class SelectAllOption {

  static template() {

    const actions = "change->views--multi-select#toggleAllCheckboxes " +
                "keydown->views--multi-select#handleKeydown " +
                "click->views--multi-select#handleClickOnListItem";
    return `
  <li tabindex="0" aria-selected="false" data-views--multi-select-target="selectAllCheckbox"
      data-action="${actions}">
    <span>
      <label class="primary-color">
          <input type="checkbox" class="select-all-checkbox">
          <span>Select All</span>
      </label>
    </span>
  </li>
  `;
  }

  static addTo(dropdown) {
    dropdown.insertAdjacentHTML("afterbegin", SelectAllOption.template());
  }
}


